export default __webpack_public_path__ + "static/media/goma.5aeebf54.gif";